<template>
    <div class="c-programmes-search" :class="[background]">
        <div class="o-container">
            <div class="o-form -form-preload" :class="{'-loading': loading}">

                <div class="c-loading__inner -search">
                    <div class="c-loading">
                        <svg class="c-loading__svg" width="100" height="100" xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path class="c-loading__letters" d="M50.2,58.4c-0.6,0-1.7,0.1-3.1,0.2c-0.3,0-0.6,0-0.9,0.1l-1.8,7.4h5.9l2-7.9C51.5,58.3,50.8,58.4,50.2,58.4"/>
                                <path class="c-loading__letters" d="M80.7,53.3c-1.2,0.4-2.5,0.8-4,1.2c-0.4,0.1-0.9,0.2-1.3,0.3c-0.2,0-0.3,0.1-0.5,0.1c0,0.2,0,0.4,0,0.6
                                    c0,2.5-1.6,5.1-5.2,5.1c-2.4,0-4.7-1-6.8-3.1l-0.4-0.4l-0.1,0.6L61,62.7L61,62.9l0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.3
                                    c2.5,1.4,5.3,2.1,8.2,2.1c7.2,0,11-5.1,11-10.1C80.9,54.6,80.8,53.9,80.7,53.3"/>
                            </g>
                            <circle class="c-loading__circle" cx="50" cy="50" r="40" stroke="url(#gradient)" stroke-width="5" fill="none" />
                            <defs>
                                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" style="stop-color:#E40032;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#ffffff;stop-opacity:1" />
                                </linearGradient>
                            </defs>
                            <g>
                                <path class="c-loading__letters" d="M40.8,38.1H23.2l-7.9,31.7h17.8l1.2-4.9H22.4l2.3-9.1h10.1l1.2-4.9H25.9l2-7.9h11.7L40.8,38.1z"/>
                                <path class="c-loading__letters" d="M39.1,30.3c-0.7,0-1.4,0.4-2.7,1.1l-0.1,0.1L30,35.2l-0.9,0.5l1,0.1l1.4,0.1h0.1l0.1,0l7.1-2.2
                                    c0.8-0.2,1.6-0.5,1.9-1.4c0.1-0.4,0-0.8-0.2-1.2c-0.2-0.4-0.5-0.6-0.9-0.8C39.4,30.3,39.2,30.3,39.1,30.3"/>
                                <path class="c-loading__letters" d="M43.3,34.5l-1.2,4.9H51l-0.2,0.8l-4,16.2c0.3,0,0.6,0,0.9-0.1c1-0.1,1.9-0.1,2.3-0.2c0.9-0.1,1.8-0.2,2.8-0.2
                                    l4.1-16.5h8.3l1-4.1l0.2-0.8L43.3,34.5L43.3,34.5z"/>
                                <path class="c-loading__letters" d="M84.5,34.4c-2.9-1.7-5.7-2.1-7.5-2.1c-3,0-5.7,1-7.5,2.9c-1.7,1.7-2.6,4.1-2.6,6.5c0,2.8,1.2,4.8,2.7,6.4
                                    c0.7,0.8,1.5,1.5,2.2,2.1c0.7,0.6,1.3,1.3,1.9,2c0.1,0.2,0.3,0.4,0.4,0.6c0,0,0.1,0,0.1,0c0.6-0.2,1.3-0.3,1.9-0.5
                                    c1.4-0.4,2.7-0.7,3.8-1.1c-0.3-0.6-0.7-1.1-1.1-1.6c-0.6-0.7-1.2-1.3-1.7-1.9l0,0l-0.9-0.9c-0.5-0.4-1-0.9-1.5-1.4
                                    c-1-1.1-1.9-2.4-1.9-3.9c0-2.1,1.6-4.4,4.6-4.4c1.1,0,3.3,0.3,5.6,2.5l0.4,0.4l0.1-0.5l1.1-4.5l0-0.1l0.1-0.2L84.5,34.4L84.5,34.4z
                                    "/>
                            </g>
                        </svg>
                    </div>
                </div>
                <div class="o-form__item__container">
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programmes-search">{{ t("Mots clés") }}</label>
                        <input class="o-input" id="programmes-search" type="text" :placeholder='t("Mots clés")' v-model="searchInput">
                        <svg class="o-ico -ico-search" role="img">
                            <title>search</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#search"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="programme-project">{{ t("Programme d'études visé") }}</label>
                        <select @change="changeSelectionProgramme()" class="o-select" id="programme-project" v-model="selectedProgramme">
                            <option value="">{{ t("Programme d'études visé") }}</option>
                            <option v-for="programme in programmes" :value="programme">{{ programme.label }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__item">
                        <label class="o-label sr-only" for="domaine-de-recherche">{{ t("Domaines de recherche") }}</label>
                        <select @change="changeSelectionDomaine()" class="o-select" id="domaine-de-recherche" v-model="selectedDomaine">
                            <option value="">{{ t("Domaines de recherche") }}</option>
                            <option v-for="domaine in domaines" :value="domaine">{{ domaine.label }}</option>
                        </select>
                        <svg class="o-ico -ico-arrow-down" role="img">
                            <title>arrow-down</title>
                            <use xlink:href="/assets/img/sprite.svg?v=2#arrow-down"></use>
                        </svg>
                    </div>
                    <div class="o-form__button c-tooltip__wrap">
                        <button class="o-button -button-bg" type="submit">
                            <span class="o-button__icos">
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                                <span class="o-button__ico">
                                    <svg class="o-ico -ico-arrow-full-right" role="img">
                                        <title>arrow-full-right</title>
                                        <use xlink:href="/assets/img/sprite.svg?v=2#arrow-full-right"></use>
                                    </svg>
                                </span>
                            </span>
                            <span class="o-button__text">
                                <span class="o-button__text__elm">
                                    {{ t("Rechercher") }} <span class="sr-only">{{ t("un projet selon les critères sélectionnés") }}</span>
                                </span>
                            </span>
                        </button>

                        <div class="c-tooltip">
                            <span class="c-tooltip__text">
                                {{ t("Voir les") }} {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!-- <pre>{{ selectedProgrammes }}</pre>
<pre>{{ selectedDomaines }}</pre> -->
    <div class="c-programmes-search__filters" :class="{'-loading': loading}">
        <div class="o-container">
            <div class="c-programmes-search__filters__wrap">
                <div class="c-programmes-search__filters__total">
                    <span>
                        {{ filteredResults.length }} {{ t("résultat") }}{{ filteredResults.length > 1 ? 's' : '' }}
                    </span>
                </div>
                <div v-if="tags.length && !loadingAttributes" class="c-programmes-search__filters__actives">
                    <div v-for="tag in tags" class="c-programmes-search__filters__actives__item">
                        <span>
                            {{ tag.obj.label }}
                        </span>
                        <button @click.prevent="removeTag(tag)" class="c-programmes-search__filters__remove">
                            <span></span>
                            <span></span>
                            <span class="sr-only">{{ t("Retirer le filtre") }} : {{ tag.obj.label }}</span>
                        </button>
                    </div>
                </div>
                <div class="c-programmes-search__filters__reset">
                    <button @click.prevent="resetSearch()" class="o-button -button-reset">
                        {{ t("Réinitialiser la recherche") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div v-if="!target" class="o-section__inner" :class="{'-loading': loading}">
        <div class="o-container">
            <div ref="resultsStart" class="c-projects-search__results">
                <template v-for="entry in filteredResultsPaged">
                    <div class="c-search-results__item -show">
                        <div class="c-search-result__header">
                            <span class="c-search-result__title o-title-4">
                                <a :href="entry.url">{{ entry.title }}</a>
                            </span>
                        </div>
                        <div class="c-search-result__desc">
                            <p v-html="entry.description"></p>
                        </div>
                        <div v-if="entry.programmes.length || entry.domaines.length" class="c-search-result__tags">
                            <span v-for="programme in entry.programmes" class="o-tag">
								<template v-if="programme">{{ programme.label.replace(/<[^>]*>?/gm, '') }}</template>
                            </span>
                            <span v-for="domaine in entry.domaines" class="o-tag">
								<template v-if="domaine">{{ domaine.label.replace(/<[^>]*>?/gm, '') }}</template>
                            </span>
                        </div>
                </div>
                </template>
            </div>
            <Pager v-if="pagerInfo.totalPages > 1 && filteredResults.length > 0" :pagerInfo="pagerInfo" @goToPage="goToPage" />
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import Pager from './Pager.vue';

    export default {
        props: {
            background: {
                type: String,
                default: ''
            },
            query: {
                type: String,
                default: false
            },
        },
        components: {
            Pager
        },
        data() {
            return {
                siteId: 1,
                loading: false,
                loadingAttributes: true,
                searchInput: '',
                searchedIds: null,
                selectedProgramme: '',
                selectedDomaine: '',
                selectedProgrammes:[],
                selectedDomaines:[],
                programmes: [],
                domaines: [],
                results: [],
                controller: null,
                pagerInfo: {
                    currentPage: 1,
                    totalPages: 1
                },
                languageUrl: '/',
                relatedToFilter: {
                    id: null,
                    title: null,
                    url: null
                },
                loadFromQuery: true,
            }
        },
        mounted() {

            let urlParams = new URLSearchParams(window.location.search);

            // console.log('query', this.query);
            if (!this.query || this.query.trim() == '' || urlParams.has('programmes') || urlParams.has('domains') || urlParams.has('s')) {
                this.loadFromQuery = false;
            }

            let lang = document.documentElement.lang;
            if (lang === 'fr-CA') {
                this.siteId = 1;
            } else {
                this.siteId = 2;
                this.languageUrl = '/en/';
            }


            this.fetchAttributes();
            this.getUrlParams();

            window.addEventListener('popstate', () => {
                this.getUrlParams();
            });

            //console.log(ProjectLocalisation["Mots clés"])
        },
        beforeUnmount() {
            window.removeEventListener('popstate', this.getUrlParams);
            if (this.controller) {
                this.controller.abort();
            }
        },
        watch: {
            'relatedToFilter.id': function () {
                this.fetchAttributes();
            },

            searchInput(newValue) {
                clearTimeout(this.searchTo);

                this.searchTo = setTimeout(() => {
                    if (this.controller) this.controller.abort();

                    this.loading = true;
                    this.search();
                }, 500);
            },

        },
        computed: {
            filteredResults() {
                let filtered = this.results;

                if (this.searchedIds!==null) {
                    if (this.searchedIds.length === 0) return [];
                    filtered = filtered.filter(entry => {
                        return this.searchedIds.includes(entry.id);
                    });

                    filtered.sort((a, b) => {
                        return this.searchedIds.indexOf(a.id) - this.searchedIds.indexOf(b.id);
                    });
                }

                if (this.selectedProgrammes.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedProgrammes.some(programme => entry.programmes.map(p => parseInt(p.id)).includes(parseInt(programme)));
                    });
                }

                if (this.selectedDomaines.length) {
                    filtered = filtered.filter(entry => {
                        return this.selectedDomaines.some(domaine => entry.domaines.map(p => parseInt(p.id)).includes(parseInt(domaine)));
                    });
                }

                this.pagerInfo.totalPages = Math.ceil(filtered.length / 10);
                this.pagerInfo.currentPage = 1;

                return filtered;
            },
            filteredResultsPaged() {
                return this.filteredResults.slice((this.pagerInfo.currentPage - 1) * 10, this.pagerInfo.currentPage * 10);
            },
            tags() {
                let tags = [];

                if (this.relatedToFilter.id) {
                    tags.push({type: 'relatedTo', obj: this.relatedToFilter.title});
                }

                this.selectedProgrammes.forEach(programmeId => {
                    let obj = this.programmes.find(p => parseInt(p.id) === parseInt(programmeId));
                    if (obj) tags.push({ type: 'programme', obj: obj });
                });
                this.selectedDomaines.forEach(domaineId => {
                    let obj = this.domaines.find(d => parseInt(d.id) === parseInt(domaineId));
                    if (obj) tags.push({ type: 'domaine', obj: obj });
                });
                return tags
            }
        },
        methods: {
            t(string) {
                return ProjectLocalisation[string];
            },
            getUrlParams() {
                let urlParams = new URLSearchParams(window.location.search);

                if (!urlParams.has('programmes') && !urlParams.has('domains') && !urlParams.has('s') && this.query) {
                    urlParams = new URLSearchParams(this.query);
                }
// console.log('urlParams', urlParams.toString());
                const relatedTo = urlParams.get('relatedTo');
                if (relatedTo) {
                    this.relatedToFilter.id = parseInt(relatedTo);
                }
                if (urlParams.has('programmes')) {
                    this.selectedProgrammes = urlParams.get('programmes').split(',').map(str => str.trim());
                }else {
                    this.selectedProgrammes = [];
                }
                if (urlParams.has('domains')) {
                    this.selectedDomaines = urlParams.get('domains').split(',').map(str => str.trim());
                }else {
                    this.selectedDomaines = [];
                }
                if (urlParams.has('s')) {
                    this.searchInput = urlParams.get('s');
                }else {
                    this.searchInput = '';
                }
                // if (this.searchInput.length >= 3) this.search();
            },
            fetchAttributes: debounce(function(e) {
                this.loading = true;
                let url = this.languageUrl + 'api/search/project-index?siteId=' + this.siteId;

                if (this.relatedToFilter.id) {
                    url += '&relatedTo=' + this.relatedToFilter.id;
                }

                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    if (data.programmes !== undefined) this.programmes = data.programmes;
                    if (data.domaines !== undefined) this.domaines = data.domaines;
                    if (data.results !== undefined) this.results = data.results;
                    if (data.relatedTo && data.relatedTo != "") {
                        this.relatedToFilter = data.relatedTo;
                    }

                    this.pagerInfo.totalPages = Math.ceil(this.results.length / 10);
                    this.loading = false;
                    this.loadingAttributes = false;
                })
            }, 100),
            goToPage(page) {
                setTimeout(() => {
                    this.pagerInfo.currentPage = page;
                    this.$refs.resultsStart.scrollIntoView({ behavior: 'smooth' });
                }, 500);
            },
            changeSelectionProgramme() {
                let current = this.selectedProgramme;
                if (current === '') return;

                this.selectedProgrammes = this.selectedProgrammes.map(id => parseInt(id));
                
                if (!this.selectedProgrammes.includes(current.id)) {
                    this.selectedProgrammes.push(current.id);
                }
                this.selectedProgramme = '';
                this.refreshUrlQuery();
            },
            changeSelectionDomaine() {
                let current = this.selectedDomaine;
                if (current === '') return;

                this.selectedDomaines = this.selectedDomaines.map(id => parseInt(id));

                if (!this.selectedDomaines.includes(current.id)) {
                    this.selectedDomaines.push(current.id);
                }
                this.selectedDomaine = '';
                this.refreshUrlQuery();
            },
            removeTag(tag) {
                // console.log(tag)
                if (tag.type === 'relatedTo') {
                    this.relatedToFilter = {
                        id: null,
                        title: null,
                        url: null
                    };
                } else if ( tag.type === 'programme') {
                    this.selectedProgrammes = this.selectedProgrammes.filter(programeId => parseInt(programeId) !== parseInt(tag.obj.id));
                } else {
                    this.selectedDomaines = this.selectedDomaines.filter(domaineId => parseInt(domaineId) !== parseInt(tag.obj.id));
                }
                this.refreshUrlQuery();
            },
            keyupSearch: debounce(function(e) {
                if (this.controller) this.controller.abort();
                if (this.searchInput.length > 3) {
                    this.search();
                } else {
                    this.searchedIds = null;
                }
            }, 500),
            search () {
                this.loading = true;
                if (this.controller) {
                    this.controller.abort();
                }

                this.controller = new AbortController();

                fetch(this.languageUrl + 'api/search/project?s='+this.searchInput+'&siteId='+this.siteId, {
                    signal: this.controller.signal,
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        if (this.searchInput.length < 3) {
                            this.searchedIds = null;
                        }else {
                            this.searchedIds = data;
                        }
                        this.loading = false;

                        if (!this.loadFromQuery) this.refreshUrlQuery();
                        this.loadFromQuery = false;
                    })
                    .finally(() => {
                    })
                    .catch(err => {
                        this.searchedIds = null;
                        this.searchInput = '';
                        this.loading = false;
                    });
            },
            refreshUrlQuery() {

                let query = '';
                if (this.selectedProgrammes.length > 0) {
                    query += 'programmes=' + this.selectedProgrammes.join(',') + '&';
                }
                if (this.selectedDomaines.length > 0) {
                    query += 'domains=' + this.selectedDomaines.join(',') + '&';
                }
                if (this.searchInput.length >=3 ) {
                    query += 's=' + this.searchInput;
                }
                const currentUrl = new URL(window.location.href);
                let pathName = currentUrl.pathname;
                pathName = pathName.replace(/(p\d)/, '');
                let newUrl = currentUrl.origin + pathName + '?' + query;
                if (this.target) {
                    newUrl = this.target + '?' + query;
                    window.location.href = newUrl;
                }
                window.history.pushState({ path: newUrl }, '', newUrl);
            },
            resetSearch() {
                this.searchInput = '';
                this.searchedIds = null;
                this.selectedProgrammes = [];
                this.selectedDomaines = [];
                this.refreshUrlQuery();
            }
        },
    }
</script>